import React, { memo } from "react";
import classNames from "classnames/bind";
import styles from "../AuthModal.module.scss";
import { FORM_MODES } from "../../../config/authModalConfig/constants";

const cx = classNames.bind(styles);

const LoginExtras = memo(({ 
  rememberLogIn, 
  setRememberLogIn, 
  onForgotPassword,
  translations
}) => {
  
  const authTranslations = translations?.Authen || {};
  
  return (
    <div className={cx("form__extras")}>
      <div className={cx("checkbox__wrapper")}>
        <input
          type="checkbox"
          id="keepLoggedIn"
          checked={rememberLogIn}
          onChange={() => setRememberLogIn(!rememberLogIn)}
        />
        <label htmlFor="keepLoggedIn">
          {authTranslations?.Keep_me_logged_in || "Keep me logged in"}
        </label>
      </div>
      <div className={cx("forgot__password")}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onForgotPassword();
          }}
        >
          {authTranslations.Forgot_your_password || "Forgot Password"}
        </a>
      </div>
    </div>
  );
});

const ForgotPasswordExtras = memo(({ onBackToLogin, translations }) => {
  const authTranslations = translations?.Authen || {};
  
  return (
    <div className={cx("switch__mode")}>
      <span>{authTranslations.Remember_password || "Remember your password?"}</span>
      <button
        type="button"
        className={cx("link__button")}
        onClick={() => onBackToLogin()}
      >
        {authTranslations.Log_in || "LOG IN"}
      </button>
    </div>
  );
});

const ModeSwitcher = memo(({ modeForm, onChangeMode, translations }) => {
  const authTranslations = translations?.Authen || {};
  
  if (modeForm === FORM_MODES.LOGIN) {
    return (
      <div className={cx("switch__mode")}>
        <span>{authTranslations.Dont_have_account || "Don't have an account?"}</span>
        <button
          type="button"
          className={cx("link__button")}
          onClick={() => onChangeMode(FORM_MODES.REGISTER)}
        >
          {authTranslations.Sign_up_now || "Sign up now."}
        </button>
      </div>
    );
  }

  if (modeForm === FORM_MODES.REGISTER) {
    return (
      <div className={cx("switch__mode")}>
        <span>{authTranslations.Already_have_account || "Already have an account?"}</span>
        <button
          type="button"
          className={cx("link__button")}
          onClick={() => onChangeMode(FORM_MODES.LOGIN)}
        >
          {authTranslations.Log_in || "LOG IN"}
        </button>
      </div>
    );
  }

  if (modeForm === FORM_MODES.FORGOT_PASSWORD) {
    return (
      <ForgotPasswordExtras 
        onBackToLogin={() => onChangeMode(FORM_MODES.LOGIN)} 
        translations={translations}
      />
    );
  }

  return null;
});

LoginExtras.displayName = "LoginExtras";
ForgotPasswordExtras.displayName = "ForgotPasswordExtras";
ModeSwitcher.displayName = "ModeSwitcher";

export { LoginExtras, ForgotPasswordExtras, ModeSwitcher };
